module.exports = __webpack_public_path__ + "img/live2d-amplify-icon.b1ebcf10.png";